window.MemberAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    //This API used to get public info only
    self.getProfile = function (memberId) {
        var deferred = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'profile/member/' + memberId, 'GET').then(function (res) {
            if (res && res.data && res.data.data) {
                var member = res.data.data;
                member.user_info.full_name = member.user_info.first_name + ' ' + member.user_info.last_name;

                deferred.resolve(member);
            }
        });

        return deferred.promise;
    };


    self.getMemberInfoByAppIdOrProspectId = function (applicationId, prospectId) {
        var deferred = $q.defer();
        var params = {};
        if (!applicationId && !prospectId) {
            throw new Error("Either prospect id or application id must be sent", date.now());
        }
        if (applicationId) {
            params.application_id = applicationId;
        }
        if (prospectId) {
            params.prospect_id = prospectId;
        }


        _protected.request( 'employer/me/users/info', 'GET', params).then(function (res) {
            if (res && res.data && res.data.data) {
                var member = res.data.data;
                member.user_info.full_name = member.user_info.first_name + ' ' + member.user_info.last_name;

                deferred.resolve(member);
            }
        });

        return deferred.promise;
    };

    // Get Demo Request
    self.getDemoRequest = function (brandId, serviceCode) {
        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            service_code: serviceCode
        };

        _protected.request('demo_request', 'GET', params).then(function (res) {
            if (res && res.data && res.data.status_code == 200 && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        });

        return deferred.promise;
    };

    //Update the request demo
    self.updateDemoRequest = function (brandId, serviceCode) {
        var deferred = $q.defer();

        var payload = {
            brand_id: brandId,
            service_code: serviceCode
        };

        _protected.request('demo_request', 'POST', payload).then(function (res) {
            if (res && res.data && res.data.status_code == 200 && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        });

        return deferred.promise;
    };

    self.getCandidateTalentPoolResume = function (groupId, candidateId) {

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'groups/' + groupId + '/candidates/' + candidateId + '/talent_pool/resume', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getMemberInvitesToApply = function (groupId, candidateId) {

        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/candidates/' + candidateId + '/job_invites', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});
